export const suscription = {
  p1: `Zarządzanie szczegółami bieżącego planu oraz opcje podniesienia lub zmiany subskrypcji.`,
  p2: `Plan roczny`,
  p3: `Plan miesięczny`,
  p4: `Aktywny do`,
  p5: `Za pokój miesięcznie`,
  p6: `Za obiekt miesięcznie`,
  p7: `Liczba miejsc`,
  p8: `Za miejsce miesięcznie`,
  p9: `Zaktualizuj subskrypcję`,
  p10: `Aktywne usługi`,
  p11: `Aktywna`,
  p12: `Nieaktywna`,
  p13: `Zaproszenie gości do check-in przez WhatsApp, zaplanowane przed ich przyjazdem do obiektu.`,
  p14: `Opinie`,
  p15: `Zaproszenie gości do oceny pobytu, które wzmacnia reputację obiektu pozytywnymi opiniami.`,
  p16: `Dostęp zdalny`,
  p17: `Rejestracja pokoi wyposażonych w inteligentne zamki i zarządzanie nimi. Konfiguracja kodów dostępu przekazywanych gościom.`,
  p18: `Weryfikacja tożsamości`,
  p19: `Weryfikujemy tożsamość gości, porównując zdjęcie z dowodu lub paszportu z selfie wykonanym na żywo.`,
  p20: `Zarządzaj subskrypcją i metodami płatności`,
  p21: `Dodawanie i usuwanie kart w razie potrzeby`,
  p22: `Obecna subskrypcja jest bezpłatna`,
  p23: `Podniesienie subskrypcji daje dostęp do zaawansowanych funkcji.`,
  p24: `Bezpłatna subskrypcja wygasa za`,
  p25: `dzień`,
  p26: `dni`,
  p27: `Aby nie stracić dostępu do zaawansowanych funkcji, warto podnieść subskrypcję teraz`,
  p28: `Dostosuj plan za pomocą usług dodatkowych`,
  p29: `miejsce`,
  p30: `miesiąc`,
  p31: `Opinie`,
  p32: `Dostęp zdalny`,
  p33: `namiot`,
  p34: `willa`,
  p35: `Weryfikacja tożsamości`,
  p36: `CAŁKOWITA POJEMNOŚĆ`,
  p37: `Całkowita pojemność to maksymalna liczba osób dopuszczona we wszystkich apartamentach, na przykład (przy wyborze 5 apartamentów całkowita pojemność może wynosić 20 miejsc). Podanie całkowitej pojemności pozwala nam precyzyjnie zarządzać subskrypcją i spełniać przepisy bezpieczeństwa.`,
  p38: `Całkowita pojemność to maksymalna liczba osób dopuszczona w willi, na przykład (przy wyborze 5 apartamentów całkowita pojemność może wynosić 20 miejsc). Podanie całkowitej pojemności pozwala nam precyzyjnie zarządzać subskrypcją i spełniać przepisy bezpieczeństwa.`,
  p39: `Całkowita pojemność to maksymalna liczba osób dopuszczona w hotelu lub hostelu, na przykład (przy wyborze 5 apartamentów całkowita pojemność może wynosić 20 miejsc). Podanie całkowitej pojemności pozwala nam precyzyjnie zarządzać subskrypcją i spełniać przepisy bezpieczeństwa.`,
  p40: `Całkowita pojemność to maksymalna liczba osób dopuszczona na kempingu, na przykład (przy wyborze 5 apartamentów całkowita pojemność może wynosić 20 miejsc). Podanie całkowitej pojemności pozwala nam precyzyjnie zarządzać subskrypcją i spełniać przepisy bezpieczeństwa.`,
  p41: `Należy podać całkowitą pojemność obiektów.`,
  p42: `WACheckin WhatsApp`,
  p43: `Własny WhatsApp Business`,
  p44: `za miejsce/miesiąc`,
  p45: `za pokój/miesiąc`,
  p46: `Rocznie`,
  p47: `Aktywuj subskrypcję`,
  p48: `Zaktualizuj subskrypcję`,
  p49: `Wybrana subskrypcja`,
  p50: `Liczba`,
  p51: `pokoi`,
  p52: `obiektów`,
  p53: `Cena miesięczna za`,
  p54: `pokoje`,
  p55: `obiekty`,
  p56: `Wybrana liczba miejsc`,
  p57: `Cena miesięczna za`,
  p58: `miejsce`,
  p59: `Rodzaj subskrypcji`,
  p60: `Roczna`,
  p61: `Miesięczna`,
  p62: `Usługi dodatkowe:`,
  p63: `Nie dodano żadnych usług`,
  p64: `Zalecane jest dodanie usługi WhatsApp`,
  p65: `Opinie`,
  p66: `Razem do zapłaty`,
  p67: `Przejdź do płatności`,
  p68: `Zaktualizuj subskrypcję`,
  p69: "ChatBot",
  
  p70: `Subskrypcja`,
  p71: `Aktywna`,
  p72: `Opcjonalne usługi dodatkowe`,

  p73: `Czy pojawiły się nowe obiekty do obsługi?`,

  p74: `Szczegóły aktualizacji i nowych usług`,
  p75: `Opłata za usługi dodatkowe lub obiekty zostanie naliczona proporcjonalnie, z uwzględnieniem dni pozostałych do końca miesiąca w bieżącej subskrypcji.`,
  p76: `Dzięki temu płaci się wyłącznie za faktyczny czas korzystania do momentu odnowienia planu.`,

  p77: `Dodane obiekty`,
  p78: `Usługi dodatkowe`,
  p79: `Dostęp zdalny`,
  p80: `ChatBot AI`,
  p81: `Cena`,
  p82: `Rocznie`,
  p83: `Miesięcznie`,
  p84: `Zaktualizuj subskrypcję`,

  p85: `Obiekty objęte subskrypcją`,
  p86: `Usługi dodatkowe`,
  p87: `Nie wykupiono żadnych usług dodatkowych`,
  p88: `ChatBot AI`,
  p89: `Dostęp zdalny`,

  p90: `W cenie planu`,

  p91: `Cena za rok`,
  p92: `Cena za miesiąc`,

  p93: `Status`,
  p94: `Aktywna`,
  p95: `Wygasa`,

  p96: `Rejestracja pokoi wyposażonych w inteligentne zamki i zarządzanie nimi. Konfiguracja kodów dostępu, które zostaną przekazane gościom.`,

  p97: `ChatBot AI`,
  p98: `Usługa chatbota opartego na AI, która szybko i sprawnie automatyzuje obsługę zapytań gości.`,

  p99: `Czy na pewno kontynuować?`,
  p100: `Zaktualizuj subskrypcję`,
  
  p101: ``,
  p102: ``,
  p103: ``,
  p104: ``,
  p105: ``,
  p106: ``,
  p107: ``,
  p108: ``,
  p109: ``,
  p110: ``,
  p111: ``,
  p112: ``,
  p113: ``,
  p114: ``,
  p115: ``,

};
